import React, { forwardRef } from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import theme from 'shared/styles/theme';

const BodyBaseBoldText = forwardRef<Text, TextProps>(
  ({ children, style, ...props }, ref) => {
    return (
      <Text ref={ref} style={[styles.bodyBaseBoldText, style]} {...props}>
        {children}
      </Text>
    );
  },
);

const styles = StyleSheet.create({
  bodyBaseBoldText: {
    ...theme.typography.body.baseBold,
    color: theme.color.text.primary,
  },
});

export default BodyBaseBoldText;
